
import { Navigation } from "./navigation";
import { Contact } from "./contact";        
import { Calculadora } from "./calculadoraIMC"; 
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const PagCalcImc = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Navigation />

      <section className="imc-wrapper py-5">
        <div className="container">
          <h2 className="text-center mb-4">Calculadora de IMC</h2>

          {/* Componente da calculadora */}
          <Calculadora />

          {/* Texto explicativo */}
          <article className="imc-text mt-5">
            <h3>Por que calcular o IMC?</h3>
            <p>
              O Índice de Massa Corporal (IMC) é uma importante métrica para
              avaliar se o peso está adequado para a altura. Ele ajuda a detectar
              riscos à saúde como obesidade, baixo peso e sobrepeso, permitindo
              ações preventivas e acompanhamento médico adequado.
            </p>
          </article>
        </div>
      </section>

      <Contact data={landingPageData.Contact} />
    </>
  );
};
